import { vfappmarket } from '../services.url';

export const SIGNING_API = {
  UPLOAD_FILES: function (acquirerEntityUid: string, appmarketAppId: string): string {
    return `${vfappmarket}/v1/apps/acquirers/${acquirerEntityUid}/app/${appmarketAppId}/upload`;
  },
};
